import * as React from "react";
import Breadcrumb from "../components/breadcrumb";
import TimeFilter from "../components/events/time-filter";
import EventsItem from "../components/events/event-item";
import Layout from "../layout/layout";
import MapView from "../components/events/map-view";
import CONSTS from "../consts";
const Masonry = require('react-masonry-component');
export default class Events extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        let NavList = [
            { Text: 'Events', Link: '' }
        ];
        let events = this.props.events.map((event, index) => {
            return React.createElement(EventsItem, Object.assign({ key: index }, event, { imgPath: `${CONSTS.STORAGEURL}/${CONSTS.EVENTCONTAINER}/${event.Id}.jpg`, updateSelectedEvent: this.props.toggleMap ?
                    () => this.props.updateSelectedEvent(event) :
                    null }));
        });
        return (React.createElement(Layout, null,
            React.createElement("div", { className: this.props.toggleMap ? "social-event map-view" : "social-event" },
                React.createElement("div", { className: "social-event-view" },
                    React.createElement(Breadcrumb, { NavList: NavList }),
                    React.createElement("h1", null, "EVENTS"),
                    React.createElement("div", { className: "social-event-content" },
                        React.createElement(TimeFilter, { timeFilter: this.props.timeFilter, updateTime: this.props.updateTime, updateMap: this.props.updateMap, toggleMap: this.props.toggleMap }),
                        React.createElement("h5", null, this.props.timeFilter === "ALL EVENTS" ? "ALL EVENTS" : "EVENTS THIS MONTH"),
                        React.createElement(Masonry, { enableResizableChildren: true }, events))),
                this.props.toggleMap ? React.createElement(MapView, { selectedEvent: this.props.selectedEvent }) : null)));
    }
}
;
//# sourceMappingURL=events.js.map